import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper";
import { FiSearch } from "react-icons/fi";
import { useTranslation } from "../i18n";

const PageExtras = () => {
  const { t, dir } = useTranslation();
  const navigate = useNavigate();
  const ads = useSelector((state) => state.ui.ads);
  const [query, setQuery] = useState("");

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const q = query.trim();
    if (q) navigate("/search?q=" + encodeURIComponent(q));
  };

  return (
    <>
      <div className="home-search">
        <form onSubmit={handleSearchSubmit}>
          <span className="ico" aria-hidden="true">
            <FiSearch size={18} />
          </span>
          <input
            type="search"
            placeholder={t("search.homePlaceholder")}
            value={query}
            style={{ padding: "0 40px" }}
            onChange={(e) => setQuery(e.target.value)}
          />
        </form>
      </div>

      {ads?.length > 0 && (
        <div className="card card--flush" style={{ marginBottom: "var(--s-6)" }}>
          <Swiper
            key={dir}
            dir={dir}
            modules={[Autoplay, Pagination]}
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{ delay: 4000 }}
            loop={ads.length > 1}
            pagination={{ clickable: true }}
            className="slider_images"
          >
            {ads.map((item, index) => (
              <SwiperSlide key={index}>
                <img src={item.url} alt="slide" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  );
};

export default PageExtras;
